/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

// @mui material components
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Chip from "@mui/material/Chip";

// Material Dashboard 2 PRO React components
import MDButton from "components/MDButton";

// Service
import EventCalendar from "examples/Calendar/EventCalendar";
import * as Defi from "services/Define";
import * as Func from "services/Function";
import { FetchData } from "services/Request";

const initFind = {
  search: "",
  saleman: "ALL",
  date_start: Func.dateFirstMonth(),
  date_stop: Func.dateEndMonth(),
};

export default function Meeting() {
  const app = useSelector((state) => state[Defi.APP_STATE]);
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [list, setList] = useState([]);
  const [find, setFind] = useState(initFind);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const view = (data) => {
    setFind(data);
    setLoading(true);
    setData([]);
    setList([]);

    FetchData("POST", `/meeting`, app.token, {
      lang: app.lang,
      search: data.search,
      date_start: data.date_start,
      date_stop: data.date_stop,
    }).then((result) => {
      if (result.status === "ok") {
        setData(result.data);
        setList(result.list);
        setLoading(false);
      } else {
        Func.exitApp();
      }
    });
  };

  return (
    <div>
      <MDButton variant="text" color="light" onClick={() => setOpen(true)}>
        <Icon>calendar_month</Icon> ตารางนัดหมาย
      </MDButton>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullScreen
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <Icon>arrow_back_ios</Icon>
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              การนัดหมาย
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogContent dividers sx={{ p: 0 }}>
          {useMemo(
            () => (
              <EventCalendar
                initialView="dayGridMonth"
                events={data}
                selectable
                editable
                datesSet={(arg) => {
                  view({
                    ...find,
                    date_start: Func.dateFormat(arg.view.activeStart),
                    date_stop: Func.dateFormat(arg.view.activeEnd),
                  });
                }}
              />
            ),
            [data]
          )}

          <TableContainer sx={{ boxShadow: 0, mb: 3 }}>
            <Table aria-label="simple table">
              <TableBody>
                {list.map((item) => (
                  <TableRow
                    key={item.id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>
                      <div>
                        <Chip
                          size="small"
                          label={`${Func.dateTimeDisplay(item.start)} ถึง ${Func.dateTimeDisplay(
                            item.stop
                          )}`}
                          color={item.className}
                        />
                      </div>
                      <div> {item.name}</div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>
    </div>
  );
}
